import { ThemeType } from "@markit/common.types";
import { useMemo } from "react";
import { Icon } from "@iconify/react";
import { DropdownMenu, DropdownMenuItem } from "../../../DropdownMenu";
import { Colors } from "../../../../utils/colors";

type ThemeDropdownToggleProps = {
  visualThemeType: ThemeType; // The theme to display in the UI (ie. for create event dark mode)
  themeType: ThemeType; // The theme that is actually set in Firebase
  onPress: (theme: ThemeType) => void;
};

// Helper component for displaying a dropdown toggle for the theme
const ThemeDropdownToggle = (props: ThemeDropdownToggleProps) => {
  const { visualThemeType, themeType, onPress } = props;

  const textColor = useMemo(
    () => (visualThemeType === ThemeType.Light ? Colors.BLACK : Colors.WHITE),
    [visualThemeType]
  );

  const themeItems: DropdownMenuItem[] = useMemo(
    () => [
      {
        title: "Light",
        key: "light",
        onPress: () => onPress(ThemeType.Light),
      },
      {
        title: "Dark",
        key: "dark",
        onPress: () => onPress(ThemeType.Dark),
      },
    ],
    [onPress]
  );

  return (
    <DropdownMenu
      dropdownItems={themeItems}
      trigger={["click"]}
      placement="bottomRight"
      altWidth={150}
    >
      <div
        className="AlignedRow"
        onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.7")}
        onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
        style={{ gap: 4 }}
      >
        <Icon
          icon={themeType === ThemeType.Light ? "ion:sunny" : "ion:moon"}
          height={16}
          style={{ color: textColor }}
        />
        <span className="bodyMedium" style={{ color: textColor }}>
          {themeType === ThemeType.Light ? "Light" : "Dark"}
        </span>
        <Icon
          icon={"ion:code"}
          height={18}
          style={{ transform: "rotate(90deg)", color: textColor }}
        />
      </div>
    </DropdownMenu>
  );
};

export default ThemeDropdownToggle;
